import MouvementStockController from './mouvement.stock.controller';
import Template from './mouvement.stock.html';

export default {
	controller: MouvementStockController,
	template: Template
};
